import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeWhile } from 'rxjs';
import { UserService } from '../core/services/mainService/user.service';
const passwordRegEx = new RegExp(
  '(?=.[a-z])(?=.[A-Z])(?=.[0-9])(?=.[$@$!%?&])[A-Za-zd$@$!%?&].{8,}'
);

@Component({
  selector: 'signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent implements OnDestroy {
  signupForm!: FormGroup;
  private _alive: boolean = true;

  constructor(
    private _formBuilder: FormBuilder,
    private _userService: UserService
  ) {
    this.signupForm = this._formBuilder.group({
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      email: [null, [Validators.required, Validators.email]],
      phoneNo: [
        null,
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          // Validators.pattern('^[+][(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]$'),
        ],
      ],
      password: [
        null,
        [
          Validators.required,
          Validators.minLength(8),
          // Validators.pattern(passwordRegEx),
        ],
      ],
      // confirmPassword: [
      //   null,
      //   [
      //     Validators.required,
      //     Validators.minLength(8),
      //     // Validators.pattern(passwordRegEx),
      //   ],
      // ],
      role:"AGENT",
      permissionFlags:0
    });
  }

  signup() {
    const payload = this.signupForm.value;
    this._userService.createUser(payload).subscribe({
      next: (res) => {
        console.log(res);
      },
      error: (err) => {
        console.log(err);
      }
    })
  }

  ngOnDestroy(): void {
    this._alive = false;
  }
}
